export default function PartnershipsSection() {
  return (
    <section id="partnerships" className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Uma Amizade que Inspira
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-red-600 to-red-400 mx-auto mb-6"></div>
        </div>

        <div className="bg-white rounded-3xl shadow-xl overflow-hidden mb-16">
          <div className="grid md:grid-cols-2 gap-0">
            <div className="relative">
              <div className="space-y-0">
                <img
                  src="https://static.readdy.ai/image/df7ad06493c3871277717cdaf248fafe/50d525b1821a4a08d0d9e92fd699ffdd.jpeg"
                  alt="Bruno e Tatiana Tominaga com Robinson Shiba - Fundador China in Box e Gendai"
                  className="w-full h-auto object-cover"
                />
                <img
                  src="https://static.readdy.ai/image/df7ad06493c3871277717cdaf248fafe/8389ef91746c23fed86a34a784bcd09f.jpeg"
                  alt="Encontro com Robinson Shiba"
                  className="w-full h-auto object-cover"
                />
                <img
                  src="https://static.readdy.ai/image/df7ad06493c3871277717cdaf248fafe/741ccb1df8b5d48daeaf29ebe78edb56.jpeg"
                  alt="Momento especial com Robinson Shiba"
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>

            <div className="p-8 md:p-12 flex flex-col justify-center">
              <div className="flex items-center mb-6">
                <div className="bg-red-100 p-3 rounded-full mr-4 w-12 h-12 flex items-center justify-center">
                  <i className="ri-heart-line text-red-600 text-2xl"></i>
                </div>
                <h3 className="text-3xl font-bold text-gray-900">Robinson Shiba</h3>
              </div>

              <p className="text-lg font-semibold text-red-600 mb-6">
                Fundador e CEO – China in Box & Gendai
              </p>

              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p>
                  Conhecemos Robinson Shiba em uma palestra que ele ministrou em São Paulo, onde fomos convidados a conhecer uma plataforma online voltada ao empreendedorismo. Na ocasião, estávamos acompanhados do meu irmão, Felipe, que decidiu ir conosco para aproveitar a oportunidade de assistir à palestra de um empreendedor excepcional — alguém que, desde o primeiro contato, demonstrava paixão genuína pelo que faz.
                </p>

                <p>
                  Robinson conduziu a palestra com entusiasmo contagiante, clareza estratégica e um amor evidente pelo empreendedorismo. Ao final, abriu espaço para conversas e trocas mais próximas. Foi nesse momento que tivemos a oportunidade de bater um papo mais profundo, que naturalmente evoluiu para a troca de contatos e o início de uma relação que ultrapassou o ambiente profissional.
                </p>

                <p>
                  Desde então, seguimos trocando mensagens, ideias e reflexões sobre empreendedorismo, estratégia, desafios do mercado e tomada de decisões. Em cada conversa, Robinson sempre se mostrou um grande mentor — com respostas sábias, conselhos estratégicos e, acima de tudo, com a generosidade e a proximidade de um amigo. Ao longo dos anos, essa relação se fortaleceu por meio de convites, encontros e experiências compartilhadas, como visitas à sua sede no Grupo Trade Foods e participações recorrentes na ABF.
                </p>

                <p>
                  A amizade entre Bruno e Tatiana Tominaga e Robinson Shiba transcende o aspecto profissional. Ela se tornou uma fonte constante de inspiração e um exemplo claro de como visão empreendedora, ética, disciplina e paixão por transformar ideias em realidade podem gerar impacto positivo e duradouro.
                </p>

                <p>
                  A trajetória de Robinson à frente de marcas icônicas como China in Box e Gendai não nos ensinou apenas sobre negócios, mas também sobre mentalidade de crescimento, inovação e responsabilidade como líderes. Sua amizade e mentoria foram fundamentais para enxergarmos com clareza a expansão e o impacto que a IchiBan Marketing Digital poderia alcançar no mercado.
                </p>

                <p className="font-semibold text-gray-900">
                  Temos profunda gratidão por seus ensinamentos, direcionamentos estratégicos e, principalmente, por sua amizade — construída com respeito, confiança e valores que admiramos.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}